import React from 'react';
import { Flex, Spacer, Box, Divider, Checkbox } from '@chakra-ui/react';
import BEControlGroup from '@molecules/BEControlGroup';

const DemoCheckbox = () => {
  return (
    <Box>
      <h2>Checkbox</h2>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>Horizontal Layout</p>
        <Spacer />
        <BEControlGroup direction="horizontal">
          <Checkbox>Checkbox Label1</Checkbox>
          <Checkbox>Checkbox Label2</Checkbox>
          <Checkbox>Checkbox Label3</Checkbox>
        </BEControlGroup>
      </Flex>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>Vertical Layout</p>
        <Spacer />
        <BEControlGroup direction="vertical">
          <Checkbox>Checkbox Label1</Checkbox>
          <Checkbox>Checkbox Label2</Checkbox>
          <Checkbox>Checkbox Label3</Checkbox>
        </BEControlGroup>
      </Flex>
    </Box>
  );
};

export default DemoCheckbox;
